import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import MainListItems from 'component/side_bar/sidebar_menu';
import Div100vh from 'react-div-100vh';
import logo from '../../assets/img/logo_black.png';
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined';
import themes from 'styles/themes';
import { RootState } from 'redux/store';
import { useSelector } from 'react-redux';
const useStyles = makeStyles((theme) => ({
    list: {
        width: 260,
        background: themes.palette.primary.light,
        display: 'flex',
        overflowY: 'auto',
        justifyContent: 'space-between',
        flexDirection: 'column',
        padding: '0 24px',
    },
    logo: {
        width: '69px',
        margin: '40px auto',
    },
    navLink: {
        textDecoration: 'none',
        color: themes.palette.primary.main,
        fontWeight: 600,
        fontSize: 14,
        display: 'block',
        margin: '24px 0',
        padding: '0 0 10px 0',
        fontFamily: 'PoppinsRegular',
        cursor: 'pointer',
    },
}));
function Sidebar({ height, handleClickOpen, setIsOpen, handleLogout, item }) {
    const classes = useStyles();
    const user = useSelector((state: RootState) => state.userDetail.me);
    return (
        <Div100vh className={clsx(classes.list)} role="presentation" onClick={() => setIsOpen(false)}>
            <div>
                <div className={classes.logo}>
                    <img src={logo} style={{ width: '100%' }} alt="logo" />
                </div>
                <MainListItems
                    handleClickOpen={handleClickOpen}
                    item={item}
                    handleDrawerToggle={() => setIsOpen(false)}
                />
            </div>
            {user && (
                <span onClick={handleLogout} className={classes.navLink}>
                    <span>
                        <ExitToAppOutlinedIcon style={{ color: 'themes.palette.primary.main', marginRight: 10 }} />
                    </span>{' '}
                    Logout
                </span>
            )}
        </Div100vh>
    );
}
export default Sidebar;
